import { BASE_URL } from "./config";
import axios from "axios";

const api = axios.create({
  baseURL: BASE_URL,
});

// Интерсептор для добавления токена авторизации
api.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерсептор для обработки ошибок авторизации
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Удаляем токен и перенаправляем на страницу входа
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Функция для очистки кэша axios
const clearApiCache = () => {
  // Очищаем все pending запросы
  api.interceptors.request.clear();
  api.interceptors.response.clear();
  
  // Пересоздаем axios инстанс для полной очистки
  const newApi = axios.create({
    baseURL: BASE_URL,
  });
  
  // Заменяем глобальный api инстанс
  Object.assign(api, newApi);
};

export { clearApiCache };
export default api;
